module.exports = __webpack_public_path__ + "static/media/red4.6d2c3e99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/red4.svg
// module id = 1339
// module chunks = 31